import type { FoCartLineToAdd, FoOfferToDelete } from '@djust-b2b/djust-front-sdk';
import { defineStore } from 'pinia';

export const useBuyingListStore = defineStore('buyinglist', {
  state: () => ({
    buyinglist: [] as any[], // List of all buying lists
    buyinglistItems: new Map(), // List of products by buying list id
    buyinglistItemsTotal: new Map<string, number>(), // API totalElements by buying list id
    buyinglistItemsPage: new Map<string, number>(), // Current API page by buying list id
    loading: false, // Indicates if a cart operation is in progress
  }),

  getters: {
    /**
     * Check if the store is currently loading
     */
    isLoading: (state) => state.loading,
  },

  actions: {
    /**
     * Set the loading state
     */
    setLoading(loading: boolean) {
      this.loading = loading;
    },

    /**
     * Clear all buyingList
     */
    clearBuyingList() {
      this.buyinglist = [];
      this.buyinglistItems.clear();
      this.buyinglistItemsTotal.clear();
      this.buyinglistItemsPage.clear();
    },

    /**
     * Add a buyingList
     */
    addBuyinglist(buyingList: BuyingList) {
      this.buyinglist.push(buyingList);
    },

    /**
     * Remove buying list by ID
     */
    removeBuyinglist(buyingListId: string) {
      this.buyinglist = this.buyinglist.filter((buyingList) => buyingList.id !== buyingListId);
      this.buyinglistItems.delete(buyingListId);
      this.buyinglistItemsTotal.delete(buyingListId);
      this.buyinglistItemsPage.delete(buyingListId);
    },

    /**
     * Update buying list by ID
     */
    updateBuyinglist(newProps: any, id: string) {
      this.buyinglist = this.buyinglist.map((bl) => {
        if (bl.id === id) {
          return Object.assign(bl, newProps);
        }
        return bl;
      });
    },

    /**
     * Remove buying list item by ID
     */
    removeBuyinglistItem(lineIdsToDelete: string[], buyingListId: string) {
      const listBeforeUpdate = this.buyinglistItems.get(buyingListId);
      this.buyinglistItems.set(
        buyingListId,
        listBeforeUpdate.filter(
          (item: BuyingListItem) =>
            !lineIdsToDelete.map((line: CartLine) => line).includes(item.offer.offerPriceId)
        )
      );
    },
  },
});
